import { getApiClient } from "@punchup/utils";
import type {
  VenueStripeAccountStatus,
  VenueStripeOnboardingLink,
} from "../../models/venue-stripe-account";

/**
 * Query-string marker on the settings URL Stripe sends the manager back to
 * (`?stripe=return` / `?stripe=refresh`). Set by the API route, read by
 * Venue Settings to reopen the Payments section.
 */
export const VENUE_STRIPE_RETURN_PARAM = "stripe";

const endpoint = (venuePageId: string) =>
  `/api/v2/manager/venue-pages/${encodeURIComponent(venuePageId)}/stripe-account`;

export async function getVenueStripeAccountStatus(
  venuePageId: string
): Promise<VenueStripeAccountStatus> {
  return getApiClient()
    .get<{ data: VenueStripeAccountStatus }>(endpoint(venuePageId))
    .then((res) => res.data);
}

export async function startVenueStripeOnboarding(
  venuePageId: string,
  returnUrl: string
): Promise<VenueStripeOnboardingLink> {
  return getApiClient()
    .post<{ data: VenueStripeOnboardingLink }>(endpoint(venuePageId), {
      returnUrl,
    })
    .then((res) => res.data);
}
